<template>
  <div id="formulario-edit-info">   
    <ExibirErrosConcept :errorsValidacao="errorsValidacao" ref="errosComponent"></ExibirErrosConcept>
    
    <vs-popup title="Pagamento" :active.sync="popUpItemCompra.popupActive">
        <div style="min-height: 400px !important;">
            <vs-alert color="danger" :active.sync="popUpItemCompra.exibirMensagem" closable icon-pack="feather" close-icon="icon-x" class="mb-3" icon="icon-info">
                    {{popUpItemCompra.mensagem}}
            </vs-alert>         
            
            <label class="vs-input--label">Produto</label>   
            <div class="flex">            
            <v-select          
                label="nome"                                                 
                :options="listaProdutos"                   
                v-model="itemCompra.produto"     
                :disabled="isDesabilitarCampo"                     
                class="v-select w-full"></v-select> 
                <vs-button @click="fetchListaProdutos" color="primary" icon="refresh" type="border"></vs-button>                                                    
            </div>
            
            <div class="vx-row mb-2">               
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Quantidade</label> 
                    <vue-autonumeric :disabled="isDesabilitarCampo"  class="vs-inputx vs-input--input normal hasValue w-full" v-model="itemCompra.qtd" :options="[{emptyInputBehavior: 'null', digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'4' }]"></vue-autonumeric>              
                </div>            
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Valor Unitário</label>     
                    <vue-autonumeric :disabled="isDesabilitarCampo"  class="vs-inputx vs-input--input normal hasValue w-full" v-model="itemCompra.valorUnitario" :options="[{emptyInputBehavior: 'null', digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'4' }]"></vue-autonumeric>                              
                </div>            
            </div>               
            <div class="flex w-full">
                <vs-button class="ml-auto mt-2" size="small" @click="inserirItemProdutoLimpar" color="success" v-if="isExibirGravar">GRAVAR</vs-button>                                            
            </div>
        </div>
    </vs-popup>

    <vx-card>        
        <div class="vx-row mb-4">
            <div class="vx-col w-1/2 ">                    
                <vs-button class="ml-auto mt-2" size="small" type="border" color="dark" @click="voltar">Voltar</vs-button>     
                <vs-button class="ml-4 mt-2" size="small" @click="gravar"    v-if="isExibirGravar" color="success">Gravar</vs-button>
                <vs-button class="ml-4 mt-2" size="small" @click="aprovar"   v-if="isExibirAprovar && isGestor" color="success">Aprovar</vs-button>
                <vs-button class="ml-4 mt-2" size="small" @click="excluir"   v-if="isExibirExcluir" color="danger">Excluir</vs-button>                                                    
            </div>
            <div class="vx-col w-1/2 items-center flex">                                    
                <p class="ml-auto"> Status: </p> <h6 class="ml-4"> {{ data_local.status }}</h6>     
            </div>
        </div>
        <div class="vx-row">            
            <div class="vx-col w-1/2"><label class="vs-input--label">Unidade Operacional</label></div>                 
            <div class="vx-col w-1/2"><label class="vs-input--label">Plano de Conta</label></div>                             
        </div>    
        <div class="vx-row">
            <div class="vx-col w-1/2 flex">
                <v-select          
                    label="nome"                                                 
                    :options="listaUnidadeOperacional"                   
                    v-model="data_local.unidadeOperacional"     
                    :disabled="isDesabilitarCampo"  
                class="v-select w-full"></v-select> 
            </div>                          
            <div class="vx-col w-1/2 flex">
                <v-select          
                    label="nome"                                                 
                    :options="listaContaPlanoConta"                   
                    v-model="data_local.contaPlanoConta"     
                    :disabled="isDesabilitarCampo"  
                class="v-select w-full"></v-select>   
            </div>                     
        </div>    
        <div class="vx-row mt-3">            
            <div class="vx-col w-1/2"><label class="vs-input--label">Fornecedor</label></div>                             
        </div>    
        <div class="vx-row">            
            <div class="vx-col w-1/2 flex">
                <v-select          
                    label="nome"                                                 
                    :options="listaFavorecido"                   
                    v-model="data_local.favorecido"     
                    :filter="pesquisarFavorecido"         
                    :disabled="isDesabilitarCampo"  
                    class="v-select w-full">
                    <template v-slot:option="option">                        
                        <span style='font-family: Verdana, sans-serif;'> {{ option.nome }} </span> <br/> {{ option.cpfCNPJ }}  - {{ option.razaoSocial }}
                    </template>
                </v-select>    
                <vs-button @click="fetchListaFavorecido" color="primary" icon="refresh" type="border"></vs-button>                                                    
            </div>                     
        </div> 
        <div class="vx-row mt-3">
            <div class="vx-col w-1/3"><label class="vs-input--label">Data da Compra</label></div>                                                     
            <div class="vx-col w-1/3"><label class="vs-input--label">Previsão de Recebimento</label></div>                                                     
            <div class="vx-col w-1/3"><label class="vs-input--label">Vencimento</label></div>                                                     
        </div>            
        <div class="vx-row">
            <div class="vx-col w-1/3 flex">
                <flat-pickr v-model="data_local.dataCompra" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker" :disabled="isDesabilitarCampo"  />
            </div>                                             
            <div class="vx-col w-1/3 flex">
                <flat-pickr v-model="data_local.previsaoRecebimento" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker" :disabled="isDesabilitarCampo"  />
            </div>                                             
            <div class="vx-col w-1/3 flex">
                <flat-pickr v-model="data_local.vencimento" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker" :disabled="isDesabilitarCampo"  />
            </div>          
        </div>
        <div class="vx-row">
            <div class="vx-col w-1/4 flex"><label class="vs-input--label">Frete </label> </div>   
            <div class="vx-col w-1/4 flex"><label class="vs-input--label">Valor Total sem frete </label> </div>   
            <div class="vx-col w-1/4 flex"><label class="vs-input--label">Valor Total com frete ({{valorTotalFormatado}})</label> </div>               
            <div class="vx-col w-1/4"><label class="vs-input--label">Forma de Pagamento</label></div>                                                                                                                                 
        </div>      
        <div class="vx-row">                                   
            <div class="vx-col w-1/4">            
                <vue-autonumeric class="vs-inputx vs-input--input normal hasValue" :disabled="isDesabilitarCampo" v-model="data_local.valorFrete" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2' }]"></vue-autonumeric>                 
            </div>
            <div class="vx-col w-1/4 items-center flex">            
                R$ {{valorTotalItensFormatado}}
            </div>
            <div class="vx-col w-1/4">            
                <vue-autonumeric class="vs-inputx vs-input--input normal hasValue" :disabled="isDesabilitarCampo" v-model="data_local.valor" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2' }]"></vue-autonumeric>                 
            </div>            
            <div class="vx-col w-1/4 flex">
                <v-select                                                                     
                    :options="CONSTANTE_FORMA_PAGAMENTO"  
                    :reduce="d => d.data"                 
                    v-model="data_local.formaPagamento"     
                    :disabled="isDesabilitarCampo"  
                class="v-select w-full"></v-select>    
            </div>    
        </div>   

        <div class="vx-row mt-3" v-if="this.data_local.hasOwnProperty('id')">            
            <div class="vx-col w-1/3"><label class="vs-input--label">Pagar Através de</label></div>                                        
            <div class="vx-col w-1/3"><label class="vs-input--label">Nota Fiscal Recebida</label></div>                                                        
            <div class="vx-col w-1/3"><label class="vs-input--label">Data Recebimento</label></div>                                                        
        </div>    
        <div class="vx-row" v-if="this.data_local.hasOwnProperty('id')">      
            <div class="vx-col w-1/3 flex">
                <v-select          
                    label="nome"                                                 
                    :options="listaInstituicao"                   
                    v-model="data_local.instituicao"     
                    :disabled="isDesabilitarCampo"  
                class="v-select w-full"></v-select>    
            </div>     
            <div class="vx-col w-1/3 flex items-center">
                <h5 v-if="data_local.conta"> {{ data_local.conta.numeroNotaFiscal }} </h5>
            </div>                                  
            <div class="vx-col w-1/3 flex items-center">
                <h5 v-if="data_local.movimentacaoEstoque"> {{ data_local.movimentacaoEstoque.dataHoraEntrada }} </h5>
            </div>                                  
        </div>  

        <div class="vx-row mt-3" v-if="data_local.conta && data_local.conta.nomeArquivoAnexado">
                <div class="vx-col w-1/2"><label class="vs-input--label">Arquivo Anexo</label></div>     
            </div>
            <div class="vx-row" v-if="data_local.conta && data_local.conta.nomeArquivoAnexado">
                <div class="vx-col w-full">
                    <a :href='`https://sac.concept.inf.br/arquivosAnexos/${data_local.conta.id}/${data_local.conta.nomeArquivoAnexado}`' target="_blank"> {{data_local.conta.nomeArquivoAnexado}} </a>
                </div>
        </div>                              
    </vx-card>  

    <vx-card class="mt-3" v-if="data_local.itemList && data_local.itemList">
        <h6> Itens da Compra </h6>
        <div class="flex mb-2 mt-2">            
            <vs-button size="small" class="nowrap ml-2" icon="add" color="primary" @click="abrirPopUpitemCompra()" v-if="isExibirGravar"></vs-button>             
        </div>
        
        <vs-table :data="data_local.itemList" noDataText="Nenhum Item." stripe v-model="itemCompra" @selected="editarItemCompra">
            <template slot="thead">
                <vs-th></vs-th>
                <vs-th></vs-th>
                <vs-th><small>Produto</small></vs-th>                                
                <vs-th><small>Qtd</small></vs-th>                              
                <vs-th><small>Valor Unitário</small></vs-th>                              
                <vs-th><small>Total</small></vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <div class="btn-group flex">
                            <vs-button size="small" type="border" color="primary" icon-pack="feather" icon="icon-search"></vs-button>
                            <vs-button  size="small" type="border" color="danger" icon-pack="feather" icon="icon-trash" v-if="isExibirGravar" @click.stop="removerItemProduto(indextr)"></vs-button>
                        </div>
                    </vs-td>
                    <vs-td :data="indextr">
                        <small>{{ (indextr + 1)}}</small>
                    </vs-td>
                    <vs-td :data="tr.produto.nome"><small> {{ tr.produto.nome }} </small></vs-td>
                    <vs-td :data="tr.qtd"> <small> {{ formatarNumero4Dec(tr.qtd) }} </small> </vs-td>
                    <vs-td :data="tr.valorUnitario"><small> {{ formatarNumero4Dec(tr.valorUnitario) }} </small></vs-td>                        
                    <vs-td><small> {{ formatarNumero4Dec(tr.qtd*tr.valorUnitario) }} </small></vs-td>
                    
                </vs-tr>
            </template>
        </vs-table>
        
    </vx-card>
  </div>
</template>

<script>
import generico from '@/generico.js'
import axios from "@/axios.js"
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'

const URL_SERVLET = "/Compra";
const NAME_ROUTE_SEARCH = "financeiro-compras-pesquisar";

import { CONSTANTE_FORMA_PAGAMENTO } from '@/constantesComboBox.js'

export default { 
  components: {  
    VueAutonumeric,
    flatPickr    
  },      
  props: {
    registroOriginal: {
      type: Object,
      required: false,
      default: function () {
        return { unidadeOperacional: null, contaPlanoConta: null, favorecido: null, dataCompra: null, previsaoRecebimento: null, vencimento: null, 
            valor: null,  valorFrete: null, formaPagamento: null, instituicao: null, status: 'RASCUNHO', itemList : [] }
       }
    },
  },
  data() {
    return {        
        listaUnidadeOperacional: [],
        listaContaPlanoConta: [],
        listaFavorecido: [],
        listaInstituicao: [],        
        listaProdutos: [],
        errorsValidacao: [],  
        data_local: JSON.parse(JSON.stringify(this.registroOriginal)),     
        configDatePicker: {          
          altInput: true,
          altFormat: "d-m-Y",
          dateFormat: "Y-m-d", 
          altInputClass: "vs-inputx vs-input--input normal hasValue text-center",
          locale: PortugueseLocale
        },              
        popUpItemCompra : {
            popupActive: false,
            exibirMensagem: false,
            mensagem: null
        }, 
        popupDuplicar: {
            popupActive: false,
            quantidadeDuplicacao: 0
        },
        itemCompra: {produto: null, qtd: null, valorUnitario: null }
    }
  },  
  created(){
        this.CONSTANTE_FORMA_PAGAMENTO = CONSTANTE_FORMA_PAGAMENTO;                   
  }, 
  mounted() {
    this.fetchListaUnidadeOperacional();
    this.fetchListaContaPlanoConta();
    this.fetchListaFavorecido();
    this.fetchListaInstituicao();      
    this.fetchListaProdutos();
    if (this.data_local != null && this.data_local.hasOwnProperty('id')) {
        this.findById();            
    } else {        
        this.data_local.formaPagamento = this.CONSTANTE_FORMA_PAGAMENTO[0].data;        
    }
  },
  computed: {  
    isGestor() {
        return (this.$store.state.AppActiveUser.perfil === 'GESTOR' || this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA');
    },    
    valorTotalFormatado(){
        if (this.data_local.valorFrete) {
            return this.valorTotalItens + this.data_local.valorFrete;
        } else {
            return this.valorTotalItens;
        }
        
    },
    valorTotalItens(){
        if (!this.data_local.itemList || !this.data_local.itemList || this.data_local.itemList.length == 0) {
            return 0;
        }

        let lItem = null;
        let valorTotal = 0;
        for (var i=0; i < this.data_local.itemList.length; i++) {
            lItem = this.data_local.itemList[i];
            valorTotal = valorTotal + parseFloat(lItem.qtd)*parseFloat(lItem.valorUnitario) ;                
        }

        return valorTotal;
    },    
    valorTotalItensFormatado(){        
        return generico.formatarNumero(this.valorTotalItens);        
    },
    isExibirExcluir() {
       return this.data_local != null && ( this.data_local.status === 'SOLICITADA') && this.data_local.hasOwnProperty("id");
    },    
    isDesabilitarCampo(){
        return this.data_local != null && this.data_local.status === 'APROVADA';
    },
    isExibirGravar(){
        return this.data_local != null && ( this.data_local.status === 'SOLICITADA' || this.data_local.status === 'RASCUNHO');
    },   
    isExibirAprovar(){
        return this.data_local != null && this.data_local.status &&  this.data_local.status === 'SOLICITADA' && ((this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') ||
               (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
               (this.$store.state.AppActiveUser.perfil === 'GESTOR') );
    },   
  },
  methods: {   
    pesquisarFavorecido(options, varTermoPesquisa) {
        if (!varTermoPesquisa) {
            return;
        }
        varTermoPesquisa = varTermoPesquisa.toUpperCase();
        return options.filter(function (c) {
            return ( ( String(c.nome).toUpperCase().indexOf(varTermoPesquisa) != -1)  || (String(c.razaoSocial).toUpperCase().indexOf(varTermoPesquisa) != -1) || 
            ( String(c.cpfCNPJ).indexOf(varTermoPesquisa) != -1));
        })
    }, 
    editarItemCompra(){        
        this.abrirPopUpitemCompra();
    },
    abrirPopUpitemCompra() {  
        this.popUpItemCompra.mensagem = null;
        this.popUpItemCompra.popupActive = true;
    },
    formatarNumero(valor) {
        return generico.formatarNumero(valor);
    },
    formatarNumero4Dec(valor) {
        return generico.formatarNumero4Decimais(valor);
    },
    fetchListaUnidadeOperacional() {      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
      
      axios.post("/UnidadeOperacional/ListarUnidadeOperacional", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
              this.listaUnidadeOperacional = response.data.Resultado.lista;              

              if (this.data_local != null && !this.data_local.hasOwnProperty("id") && this.listaUnidadeOperacional.length > 0) {
                    this.data_local.unidadeOperacional = this.listaUnidadeOperacional[0];
              }
              
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })                
    }, 
    fetchListaContaPlanoConta() {      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
      params.append('grupoPlanoConta.tipo',  'DESPESA');
      
      axios.post("/ContaPlanoConta/listar", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
            this.listaContaPlanoConta = response.data.Resultado.lista;              
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })                
    }, 
    fetchListaFavorecido() {      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
      params.append('ehFornencedor',  true);
      
      axios.post("/Favorecido/ListarFavorecido", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
            this.listaFavorecido = response.data.Resultado.lista;
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })                
    }, 
    fetchListaInstituicao() {      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
            
      axios.post("/Instituicao/listar", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
            this.listaInstituicao = response.data.Resultado.lista;             

            if (this.data_local != null && !this.data_local.hasOwnProperty("id") && this.listaInstituicao.length > 0) {
                  this.data_local.instituicao = this.listaInstituicao[0];
            }
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })                
    }, 
    fetchListaProdutos() {      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
            
      axios.post("/Produto/ListarProduto", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
            this.listaProdutos = response.data.Resultado.lista;              
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })                
    },     
    findById() {
        this.$vs.loading();
    
        const params = new URLSearchParams();               
        params.append('empresa.id', this.$store.state.AppActiveUser.empresa.id);    
        params.append('id', this.data_local.id);           
                
        axios.post(URL_SERVLET + "/Recuperar", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close();
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                this.data_local = response.data.Compra;      

                if (!Array.isArray(response.data.Compra.itemList)) {
                    let itemIndividual = response.data.Compra.itemList;
                    this.$delete(this.data_local.itemList, 'item');                    
                    this.$set(this.data_local.itemList, 'item', []);                    
                    this.data_local.itemList.push(itemIndividual);                    
                }
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - findById - " + error); 
        })  
    }, 
    excluir() {
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja excluir ?', acceptText: 'Sim', cancelText: 'Não', accept: this.excluirRequest
        });
    },
    excluirRequest() {
        this.$vs.loading();  
        const params = new URLSearchParams();                
        params.append('id', this.data_local.id);   
                
        axios.post(URL_SERVLET + "/Remover", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/' });
            } else {
                this.$vs.loading.close();
                if (response.data.toUpperCase().indexOf('ERRO') != -1) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data, acceptText: 'OK'})
                } else {
                    this.$vs.notify({
                        title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                        text: response.data,
                    });
                    this.$router.push({ name: NAME_ROUTE_SEARCH })
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - excluirRequest - " + error); 
        })  
    }, 
    aprovar() {
        this.$refs.errosComponent.iniciar();
        this.errorsValidacao = [];    
        if (!this.data_local.instituicao) { this.errorsValidacao.push("Instituição obrigatório"); }
        if (this.errorsValidacao.length) {
            return;
        }   

        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja aprovar a compra ?', acceptText: 'Sim', cancelText: 'Não', accept: this.aprovarRequest
        });
    },
    aprovarRequest() {            
        this.submeter("/Aprovar");
    },       
    gravar() {
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja gravar a compra ?', acceptText: 'Sim', cancelText: 'Não', accept: this.gravarRequest
        });
    },
    gravarRequest() {        
        this.submeter("/Gravar");
    },
    submeter(urlPost) {        
        if (this.formularioValido()) { 
            this.$vs.loading();  
            const params = new URLSearchParams();    

            if (this.data_local.hasOwnProperty('id')) {
                params.append("id", this.data_local.id);
            }
            params.append("unidadeOperacional.id", this.data_local.unidadeOperacional.id);
            params.append("unidadeOperacional.nome", this.data_local.unidadeOperacional.nome);
            params.append("contaPlanoConta.id", this.data_local.contaPlanoConta.id);
            params.append("contaPlanoConta.nome", this.data_local.contaPlanoConta.nome);
            params.append("favorecido.id", this.data_local.favorecido.id);
            params.append("favorecido.nome", this.data_local.favorecido.nome);
            if (this.data_local.instituicao) {
                params.append("instituicao.id", this.data_local.instituicao.id);
                params.append("instituicao.nome", this.data_local.instituicao.nome);                            
            }
            params.append("dataCompra", this.data_local.dataCompra);
            params.append("previsaoRecebimento", this.data_local.previsaoRecebimento);
            params.append("vencimento", this.data_local.vencimento);
            params.append("formaPagamento", this.data_local.formaPagamento);
            params.append("valor", this.data_local.valor);
            if (this.data_local.valorFrete) {
                params.append("valorFrete", this.data_local.valorFrete);
            }            
            params.append("JSONItems", JSON.stringify(this.data_local.itemList));

            if (this.data_local.status && this.data_local.status !== 'RASCUNHO') {
                params.append("status", this.data_local.status);
            }
            

            axios.post(URL_SERVLET + urlPost, params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                this.$vs.loading.close();
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                    this.$router.push({ path: '/' });
                } else {                    
                    if (response.data.Compra.erroOperacao) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.Compra.mensagemResultadoOperacao, acceptText: 'OK'})
                    } else {                                                
                        this.$vs.notify({
                            title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                            text: response.data.Compra.mensagemResultadoOperacao,
                        });

                        this.data_local = response.data.Compra;  
                        this.findById();
                    }                   
                }
            })
            .catch((error) => { 
                this.$vs.loading.close();
                /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }
         
    },
    voltar() {
        this.$router.push({
            name: NAME_ROUTE_SEARCH                     
        })
    },
    formularioValido() {
        this.$refs.errosComponent.iniciar();
        this.errorsValidacao = [];
    
        if (!this.data_local.unidadeOperacional) { this.errorsValidacao.push("UNidade Operacional obrigatório"); }
        if (!this.data_local.contaPlanoConta) { this.errorsValidacao.push("Plano de Conta obrigatório"); }
        if (!this.data_local.favorecido) { this.errorsValidacao.push("Fornecedor obrigatório"); }
        if (!this.data_local.dataCompra) { this.errorsValidacao.push("Data da Compra obrigatório"); }
        if (!this.data_local.previsaoRecebimento) { this.errorsValidacao.push("Previsão de Recebimento obrigatório"); }
        if (!this.data_local.vencimento) { this.errorsValidacao.push("Vencimento obrigatório"); }
        if (!this.data_local.valor) { this.errorsValidacao.push("Valor obrigatório"); }           
        
        if (!this.data_local.itemList || !this.data_local.itemList || !this.data_local.itemList.length) { this.errorsValidacao.push("Insira pelo menos um item na compra"); }
        
    
        if (!this.errorsValidacao.length) {
            return true;
        }   
        return false;
    },   
    formularioValidoItemCompra() {
        
        if (!this.itemCompra.produto) {
            this.popUpItemCompra.mensagem = "Informe o produto";
            this.popUpItemCompra.exibirMensagem = true;
            return false;
        }

        if (!this.itemCompra.qtd) {
            this.popUpItemCompra.mensagem = "Informe a quantidade";
            this.popUpItemCompra.exibirMensagem = true;
            return false;
        }

        if (!this.itemCompra.valorUnitario) {
            this.popUpItemCompra.mensagem = "Informe o valor do pagamento";
            this.popUpItemCompra.exibirMensagem = true;
            return false;
        }
        return true;
    },   
    inserirItemProdutoLimpar() {
        if (this.formularioValidoItemCompra()) {
            this.data_local.itemList.push(this.itemCompra);            
            this.itemCompra = {produto: {id: null, nome: null}, idValue: null, qtd: null, valorUnitario: null  };
        }
    }, 
    removerItemProduto(indice) {      
      this.data_local.itemList.splice(indice,1);
    },  
  }
}
</script>

<style scoped>
  .tabelaComScroll {      
      overflow: auto;  
      height: calc(100vh - 300px);
      position: relative;      
    } 

    

</style>

